/** Native CLOCK_MONOTONIC and browser performance/audio clocks have different
 * origins. Use the least delayed observation for their offset, then schedule
 * PCM against that shared timeline instead of accumulating arrival jitter.
 * This is a playback mapping, not an absolute latency measurement. */
export class BrowserMediaClock {
  private offset: number | null = null;
  private windowStart = 0;
  private audioOffset: number | null = null;
  get hasAudio(): boolean {return this.audioOffset !== null;}
  reset(): void {this.offset = null;this.audioOffset = null;}
  /** Bind native PTS to samples actually scheduled in the audio render graph.
   * Only video follows clock drift; PCM blocks remain sample-contiguous. */
  bindAudio(nativeMs: number, audioTime: number, discontinuity = false): void {
    const offset = audioTime - nativeMs / 1000;
    if (this.audioOffset === null || discontinuity) this.audioOffset = offset;
    else this.audioOffset += (offset - this.audioOffset) * 0.02;
  }
  videoTime(nativeMs: number, performanceMs: number, audioNow: number): number {
    return performanceMs + (this.audioTime(nativeMs, performanceMs, audioNow) - audioNow) * 1000;
  }
  captureAgeMs(nativeMs:number,performanceMs:number):number {
    return this.offset===null?0:Math.max(0,performanceMs-nativeMs-this.offset);
  }
  rebaseTransport(nativeMs:number,performanceMs:number):void {
    this.offset=performanceMs-nativeMs;this.windowStart=nativeMs;
  }
  observe(nativeMs: number, performanceMs: number): void {
    if (this.offset === null || nativeMs - this.windowStart > 60000) {
      this.offset = performanceMs - nativeMs;
      this.windowStart = nativeMs;
    } else this.offset = Math.min(this.offset, performanceMs - nativeMs);
  }
  audioTime(nativeMs: number, performanceMs: number, audioNow: number): number {
    if (this.audioOffset !== null) return nativeMs / 1000 + this.audioOffset;
    return audioNow + (nativeMs + (this.offset ?? performanceMs - nativeMs) + 20 - performanceMs) / 1000;
  }
}
